import { httpRequest } from '@v4/http/request';
import { getApiUrl } from '@v4/config';
import { stringifyUrl } from '@v4/common/utils/url';

export const baseUrl = `${getApiUrl()}/dkwp/v3/car`;

/**
 * Gets the submodel badges
 *
 * @param {string} make make name
 * @param {string} model model name
 * @returns {Promise<object>}
 */
export const fetchBadges = (make, model) =>
    httpRequest({
        url: `${baseUrl}/${make}/${model}/badges`,
    });

export const fetchSimilar = (make, model, query) =>
    httpRequest({ url: stringifyUrl({ url: `${baseUrl}/${make}/${model}/similar`, query }) });

export const fetchHeadToHead = (make, model, query) =>
    httpRequest({ url: stringifyUrl({ url: `${baseUrl}/${make}/${model}/head-to-head`, query }) });

export const fetchConfigurator = (make, model, query) =>
    httpRequest({ url: stringifyUrl({ url: `${baseUrl}/${make}/${model}/configurator`, query }) });
